import React from "react";
import PropTypes from "prop-types";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";

import { ReactComponent as WitnessQuestionnaireIcon } from "../../assets/icons/questionnaire.svg";
import { ReactComponent as HearingFormIcon } from "../../assets/icons/hearing-form.svg";
import { ReactComponent as FineNoticeIcon } from "../../assets/icons/fine-notice.svg";
import { ReactComponent as NothingReceivedIcon } from "../../assets/icons/nothing-received.svg";
import { ReactComponent as UnsureIcon } from "../../assets/icons/dont-know.svg";
import { ReactComponent as AccidentIcon } from "../../assets/icons/accident.svg";
import { ReactComponent as CellphoneIcon } from "../../assets/icons/cellphone.svg";
import { ReactComponent as NoparkingIcon } from "../../assets/icons/no-parking.svg";
import { ReactComponent as TrafficLightIcon } from "../../assets/icons/traffic-light.svg";
import { ReactComponent as SpeedLimitIcon } from "../../assets/icons/speed-limit.svg";
import { ReactComponent as DistanceIcon } from "../../assets/icons/too-close.svg";
import { ReactComponent as AlcoholIcon } from "../../assets/icons/alcohol.svg";

const iconComponents = {
  ACCIDENT: AccidentIcon,
  MOBILE_PHONE: CellphoneIcon,
  PARKING: NoparkingIcon,
  SPEEDING: SpeedLimitIcon,
  WITNESS_QUESTIONNAIRE: WitnessQuestionnaireIcon,
  HEARING_FORM: HearingFormIcon,
  FINE_NOTICE: FineNoticeIcon,
  UNSURE: UnsureIcon,
  RED_LIGHT: TrafficLightIcon,
  NONE: NothingReceivedIcon,
  DISTANCE: DistanceIcon,
  ALCOHOL_DRUGS: AlcoholIcon,
};

const SvgIcon = ({ type, ...props }) => {
  const IconComponent = iconComponents[type];

  if (IconComponent) {
    return <IconComponent {...props} />;
  }

  return <InsertDriveFileOutlinedIcon {...props} />;
};

SvgIcon.propTypes = {
  type: PropTypes.oneOf([
    "ACCIDENT",
    "MOBILE_PHONE",
    "PARKING",
    "SPEEDING",
    "WITNESS_QUESTIONNAIRE",
    "HEARING_FORM",
    "FINE_NOTICE",
    "UNSURE",
    "RED_LIGHT",
    "NONE",
    "DISTANCE",
    "ALCOHOL_DRUGS",
  ]).isRequired,
};

export default SvgIcon;
